import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';

import QuestionAdditionButton from './AskQuestion/QuestionAdditionButton';
import ModuleAdditionButton from './AddModule/ModuleAdditionButton';
import ConditionalAdditionButton from './DoConditional/ConditionalAdditionButton';
import OtherActionSelector from './OtherActionSelector/OtherActionSelector';

export default function ActionAdditionForm(props) {
  const { actionListId, reloadCallback } = props;

  return (
    <Grid container>
      <QuestionAdditionButton
        actionListId={actionListId}
        reloadCallback={reloadCallback}
      />
      <ModuleAdditionButton
        actionListId={actionListId}
        reloadCallback={reloadCallback}
      />
      <ConditionalAdditionButton
        actionListId={actionListId}
        reloadCallback={reloadCallback}
      />
      <OtherActionSelector
        actionListId={actionListId}
        reloadCallback={reloadCallback}
      />
    </Grid>
  );
}

ActionAdditionForm.propTypes = {
  actionListId: PropTypes.number.isRequired,
  reloadCallback: PropTypes.func,
};

ActionAdditionForm.defaultProps = {
  reloadCallback: null,
};
